import React, { ReactElement } from "react";
import { useNavigate } from "react-router-dom";

import Stack from "@mui/material/Stack";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";

import GenericStatus from "components/shared/status/GenericStatus";
import AntSwitch from "components/shared/switch/AntSwitch";
import ZoneMenu from "components/zone/ZoneMenu";

import { getAllZone, updateZoneStatus } from "redux/handlers/zoneHandler";

import ZoneReducer from "redux/reducers/zoneReducer";

import { useAppDispatch } from "hooks/reduxHook";

import { zonesTableData } from "types/global/table";

const ZonesTable = ({
 rowData,
 index
}: {
 rowData: zonesTableData;
 index: number;
}): ReactElement => {
 const dispatch = useAppDispatch();
 const navigate = useNavigate();

 const handleSwitchToggle = async (ispId: number, zoneId: number) => {
  await dispatch(updateZoneStatus(ispId, zoneId));
  dispatch(getAllZone(0, 10));
 };

 const handleRedirectToZoneDetails = (id: number, domain: string, active: boolean) => {
  dispatch(ZoneReducer.actions.setZoneDetails(rowData));
  active && navigate(`/app/zone/${id}/details`, { state: { key: domain } });
 };

 return (
  <TableRow
   key={`zone-list-${index}`}
   sx={{ cursor: "pointer" }}
   onClick={() => handleRedirectToZoneDetails(rowData.id, rowData.zone, rowData.active)}>
   <TableCell component="th" scope="row">
    <Stack direction="row" alignItems="center" spacing={1}>
     <GenericStatus status={rowData.active ? "online" : "offline"} />
    </Stack>
   </TableCell>
   <TableCell>
    <Typography variant="subtitle2">{rowData.zone}</Typography>
   </TableCell>
   <TableCell component="th" scope="row">
    <Stack direction="row" justifyContent="center" spacing={0.5}>
     <Typography variant="small">{rowData.dnsRr}</Typography>
    </Stack>
   </TableCell>
   <TableCell component="th" scope="row">
    <Stack direction="row" justifyContent="center" spacing={0.5}>
     <Typography variant="small">{rowData.mail}</Typography>
    </Stack>
   </TableCell>
   <TableCell component="th" scope="row">
    <Stack direction="row" justifyContent="center" spacing={0.5}>
     <Typography variant="small">{rowData.ttl}</Typography>
    </Stack>
   </TableCell>
   <TableCell component="th" scope="row">
    <Stack direction="row" justifyContent="center" spacing={0}>
     <AntSwitch
      checked={rowData.active}
      onClick={() => handleSwitchToggle(rowData.isp_id, rowData.zone_id)}
     />
    </Stack>
   </TableCell>
   <TableCell component="th" scope="row" onClick={(e) => e.stopPropagation()}>
    <Stack direction="row" justifyContent="right" spacing={0}>
     <ZoneMenu
      zone_id={rowData.zone_id}
      data={rowData.records}
      isp_id={rowData.isp_id}
      name={rowData.zone}
     />
    </Stack>
   </TableCell>
  </TableRow>
 );
};

export default ZonesTable;
